import React from 'react';
import { TagsWidgetConfig, WidgetBase } from '@mm/state/model/WidgetModel';
import { TagsWidget } from '../../../../../common/widgets/TagsWidget/TagsWidget';
import { useSelector } from 'react-redux';
import { SlideoutMenu as Menu } from '../../components/SlideoutMenu';

import { StoreState } from '@mm/state/store-interfaces';
import { PlatformType } from '@mm/state/model/CampaignsModel';
import css from './SlideoutTagWidgetEditor.module.css';
import { Heading } from '@mm/components';
import { CloseOutlined, TagOutlined } from '@ant-design/icons';
import { useSlideoutOnClose } from '../SlideoutEmail/SlideoutEmail';
import { SlideOutMenuType } from '@mm/state/interfaces/view';

export type TagWidgetEditorProps = {
  menuType: SlideOutMenuType;
  widgetId: number;
  platforms?: PlatformType[];
};

export const SlideoutTagWidgetEditor = ({
  menuType,
  widgetId,
  platforms,
}: TagWidgetEditorProps) => {
  const { setRef, close: closeSlideout } = useSlideoutOnClose(async () => {},
  menuType);

  const widgets = useSelector((state: StoreState) => state?.widget?.entities);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const widget = widgets.find(w => w.id === widgetId)!;

  return (
    <Menu className={css.container} setRef={setRef}>
      <div className={css.header}>
        <Heading size={3}>Tags</Heading>
        <span className={css.close} onClick={closeSlideout}>
          <CloseOutlined style={{ color: '#262626' }} />
        </span>
      </div>
      <Menu.Content className={css.content}>
        {widget ? (
          <TagsWidget
            className={css.tagsWidget}
            widget={widget as unknown as WidgetBase<TagsWidgetConfig>}
            platforms={platforms}
          />
        ) : (
          <span>Couldn't load widget</span>
        )}
      </Menu.Content>
    </Menu>
  );
};
